import React, {Component} from 'react'
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import {Button} from "reactstrap";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import Select from "react-select";
import {Types} from "../index";
import API from "@beardeddevops/react.api";

export default class RegionSelectToggle extends Component {
	constructor(props) {
		super(props);
		this.state = {...this.state, metroWalkRegions: [], popularRegions: []}
	}

	async componentDidMount() {
		const metroWalkRegions = await this.getRegions('metroWalk');
		const popularRegions = await this.getRegions('popularRegions');
		this.setState({metroWalkRegions, popularRegions});
	}

	getRegions = async (filterType) => {
		let model = new API.BuildClass(Types.Regions._name, API.RequestType.READ_ALL);
		this.read = 'GET_ALL';
		model.limit = 5000;
		model.filter = {
			'filterPopular': filterType === 'popularRegions',
			'filterMetroWalk': filterType === 'metroWalk',
		}
		try {
			this.regions = await model.submit(null, this.read);
			this.regions = Object.keys(this.regions).map((key) => this.regions[key]);
			this.regions = this.regions[3];

			return this.regions.map((region) => {return {"label": region.name, "value": region.pkey}})
		} catch (error) {
		}
	}

	handleMetroWalkRegions = async (handle) => {
		if (!this.props.multi) {
			if (handle === 'metro-walk-start') {
				await this.handleRegions(this.state.metroWalkRegions[0]);

				return;
			}
			let currentRegion = this.props.parent.state.filterRegion ?? null;
			if (currentRegion) {
				let currentIndex = 0;
				this.state.metroWalkRegions.forEach((region) => {
					if (region.value == currentRegion) {
						currentIndex = this.state.metroWalkRegions.indexOf(region)
					}
				})
				if (currentIndex >= 0) { //selected region exists in this.state.metroWalkRegions
					if (handle) { //next region
						if (currentIndex + 1 >= this.state.metroWalkRegions.length) { //end of array
							await this.handleRegions(this.state.metroWalkRegions[0])
						} else {
							await this.handleRegions(this.state.metroWalkRegions[currentIndex + 1])
						}
					} else { //previous region
						if (currentIndex - 1 < 0) { //current region is already index0
							await this.handleRegions(this.state.metroWalkRegions[this.state.metroWalkRegions.length - 1])
						} else {
							await this.handleRegions(this.state.metroWalkRegions[currentIndex - 1])
						}
					}
				} else {
					await this.handleRegions(this.state.metroWalkRegions[0])
				}
			} else {
				await this.handleRegions(this.state.metroWalkRegions[0])
			}

			return;
		}
		//if multiple regions are set, default to first one in the array
		if (this.props.parent.state.selectedRegions.length > 1 || this.props.parent.state.selectedRegions.length === 0) {
			if (handle) {
				await this.handleRegions([this.state.metroWalkRegions[0]]);
			} else {
				await this.handleRegions([this.state.metroWalkRegions[this.state.metroWalkRegions.length - 1]]);
			}
		} else {
			let keyed;
			this.state.metroWalkRegions.map((region, key) => {
				if (JSON.stringify(region.value) === JSON.stringify(this.props.parent.state.selectedRegions[0].value)) {
					keyed = key + (handle ? 1 : -1);
				}
			});
			if (keyed >= this.state.metroWalkRegions.length) {
				keyed = 0;
			}
			if (keyed === -1) {
				keyed = this.state.metroWalkRegions.length - 1;
			}
			await this.handleRegions([this.state.metroWalkRegions[keyed]]);
		}
	}

	handleRegions = async (value) => {
		localStorage.setItem("users", JSON.stringify([]));
		this.props.parent.state.selectedUsers = [];
		if (!this.props.multi) {
			//this.props.parent.setState({selectedRegion: value});
			this.props.parent.state.filterRegion = value.value;

			await this.props.handleRegionsCallback().then();
			if (typeof (this.props.parent.props.setRegion) === 'function') {
				this.props.parent.props.setRegion(value.value);
			}

			return;
		}
		if (value) {
			let regions = [];
			for (let i = 0; i < value.length; i++) {
				regions.splice(0, 0, value[i]);
			}
			localStorage.setItem("regions", JSON.stringify(value));
			this.props.parent.state.selectedRegions = regions;
		} else {
			this.props.parent.state.selectedRegions = [];
			localStorage.setItem("regions", JSON.stringify([]));
		}
		//refreshing the data after passing filters
		this.props.handleRegionsCallback();
	}

	render() {
		return (
			<div className={'row'}>
				{!!!this.props.noCycle && <div className={"col-xs"}>
					<IconButton onClick={() => this.handleMetroWalkRegions(0)}><LeftArrowIcon/></IconButton>
					{!!this.props.multi ? <Button
						onClick={() => {
							this.handleRegions(this.state.popularRegions)
						}}
						color='primary'
					>
						All
					</Button> : <Button
						onClick={() => {
							this.handleMetroWalkRegions('metro-walk-start')
						}}
						color='primary'
					>
						Metros
					</Button>}
					<IconButton onClick={() => this.handleMetroWalkRegions(1)}><RightArrowIcon/></IconButton>
				</div>}
				<div className={"col"}>
					<Select
						key={this.props.parent.state.regions}
						placeholder={"Region Select"}
						isMulti={this.props.multi}
						isClearable={this.props.multi}
						value={this.props.multi ? this.props.parent.state.selectedRegions.map(region => {
							return (
								{value: region.value, label: region.label})
						}) : this.props.parent.state.selectedRegion}
						onChange={this.handleRegions}
						options={this.props.parent.state.regions.map(region => {
							return (
								{value: region.pkey, label: region.name})
						})}
					/>
				</div>
			</div>
		)
	}
}